import { Button } from 'antd';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ChatContent from './ChatContent';
import ChatInquiryDetailButton from './ChatInquiryDetailButton';
import useDraggableChatWindow from './useDraggableChatWindow';
// IMG
import closeIcon from '@icons/Icon_Close_10.svg';
import chatMaxIcon from '@icons/Icon_chat_open.svg';
import chatStore from '@stores/chatStore';

export default function ChattingRoom({ chattingRoom, index }) {
  const roomRef = useRef();
  const { t } = useTranslation();
  const { openChattingRoom, closeChattingRoom, removeChattingRoom, setFocus } =
    chatStore();
  const drag = useDraggableChatWindow(roomRef, t, chattingRoom.open);

  return (
    <div
      ref={roomRef}
      onFocus={() => {
        setFocus(chattingRoom.id, true);
      }}
      onBlur={() => {
        setFocus(chattingRoom.id, false);
      }}
      tabIndex={index}
      className="flex-column align–center justify-center"
      style={{
        pointerEvents: 'auto',
        border: chattingRoom.open
          ? '1px solid #CFCFCF'
          : chattingRoom.newChat
          ? '1px solid #FF6D9C'
          : '1px solid #54AFED',
        borderRadius: chattingRoom.open ? '4px' : '10px',
        backgroundColor: '#FFF',
        padding: chattingRoom.open ? '0' : '0 20px',
        position: 'relative',
        boxShadow: '0px 8px 16px 0px #0000001A',
        height: chattingRoom.open ? 'calc(100vh - 110px)' : '68px',
        width: chattingRoom.open ? '388px' : '258px',
        minWidth: chattingRoom.open ? '388px' : '258px',
        maxWidth: chattingRoom.open ? '388px' : '258px',
        overflow: 'hidden',
        // transform은 즉시 반영해 포인터를 따라가고 크기 전환만 애니메이션합니다.
        transition: 'width 0.3s ease, height 0.3s ease, border-radius 0.3s ease',
        boxSizing: 'border-box',
        ...drag.transformStyle,
      }}
    >
      {!chattingRoom.open && (
        <div
          className="flex-row align-center"
          style={{ position: 'absolute', right: 3, bottom: 3 }}
        >
          <ChatInquiryDetailButton reservationId={chattingRoom.id} compact />
          <Button
            type="text"
            icon={<img alt={t('common:imageAlt.maximize')} src={chatMaxIcon} />}
            style={{
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '30px',
              height: '30px',
            }}
            onPointerDown={(event) => event.stopPropagation()}
            onClick={() => {
              if (chattingRoom.open) {
                closeChattingRoom(chattingRoom.id);
              } else {
                openChattingRoom(chattingRoom.id);
              }
            }}
          />
          <Button
            type="text"
            icon={<img alt={t('common:imageAlt.close')} src={closeIcon} />}
            style={{
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '30px',
              height: '30px',
            }}
            onPointerDown={(event) => event.stopPropagation()}
            onClick={() => {
              removeChattingRoom(chattingRoom.id);
            }}
          />
        </div>
      )}

      {!chattingRoom.open && (
        <div
          {...drag.dragHandleProps}
          className="flex-column justify-center"
          style={{
            width: '100%',
            height: '100%',
            paddingBottom: '26px',
            cursor: 'move',
            touchAction: 'none',
          }}
        >
          <span
            style={{
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '20px',
              color: '#000',
              whiteSpace: 'nowrap',
              overflow: 'hidden' /* 넘치는 텍스트를 숨김 */,
              textOverflow: 'ellipsis',
              cursor: 'inherit',
            }}
          >
            {chattingRoom.reservation?.travel?.name}
          </span>
          <span
            style={{
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '20px',
              color: '#000',
              whiteSpace: 'nowrap',
              overflow: 'hidden' /* 넘치는 텍스트를 숨김 */,
              textOverflow: 'ellipsis',
              cursor: 'inherit',
            }}
          >
            {chattingRoom.reservation?.reservationNumber
              ? chattingRoom.reservation?.reservationNumber
              : ''}
          </span>
        </div>
      )}
      <div
        style={{
          // 중간 form 부분
          display: chattingRoom.open ? 'initial' : 'none',
          height: '100%',
        }}
      >
        <ChatContent
          chattingRoom={chattingRoom}
          messages={chattingRoom.messages}
          open={chattingRoom.open}
          dragHandleProps={drag.dragHandleProps}
          setOpen={() => {
            if (chattingRoom.open) {
              closeChattingRoom(chattingRoom.id);
            } else {
              openChattingRoom(chattingRoom.id);
            }
          }}
        />
      </div>
      <span
        aria-live="polite"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {drag.statusText}
      </span>
    </div>
  );
}
